export default {
  questionnaire: '',
  answeredForms: ''
};